import { collection, getDocs, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { MetadataTagDB } from "./MetadataTags";
import { MetadataTag } from "../types";

export const getMetadataTagsList = async (): Promise<MetadataTag[]> => {
  const metadataTagsRef = collection(db, "metadataTags");

  const q = query(metadataTagsRef);
  const metadataTagsSnapshot = await getDocs(q);

  return metadataTagsSnapshot.docs.map((doc) =>
    new MetadataTagDB(doc).toMetadataTag(),
  );
};
